import {
  AccessControl,
  toast,
  DeleteModal,
  useIntl,
  getTranslatedText
} from '@nile/components';
import { DEFAULT_VIEW } from '@nile/reports/src/modules/home/constants';
import {
  Badge,
  Button,
  ButtonGroup,
  Heading
} from '@superops/ui-design-system';
import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { AccountClient } from '@nile/graphql';
import { DELETE_CHARTS } from '@nile/reports/src/modules/charts/graphql';
import ChartHome from '@nile/reports/src/modules/charts/components/pages/ChartHome';
import { FormattedMessage, injectIntl } from 'react-intl';
import { NavToggle } from '@nile/reports/src/modules/home/components/utils';
import ReportsContext from '@nile/reports/src/modules/home/contexts/Reports';
import { isEmpty } from 'lodash';
import { SVGIcon } from '@superops/super-icons';
import { useMutation } from '@apollo/client';
import { StyledToolbar } from './styles';

/**
 * Functional component to display chart view name
 * @param props
 * @returns JSX
 */
const ChartInfoToolbar = (props) => {
  const { activeView } = props;

  const { name } = activeView.data;

  return (
    <div className="f11 full-width">
      <Heading element="h1">
        <div className="flex center">
          <div className="flex center">
            <div className="mr-20" onClick={props.toggleNavMenu}>
              <NavToggle />
            </div>
            {name}
          </div>
        </div>
      </Heading>
    </div>
  );
};

/**
 * Component to display chart toolbar
 * @param props
 * @returns JSX
 */
const ChartToolbar = (props) => {
  const reportsContext = useContext(ReportsContext);

  const [openChart, setOpenChart] = useState(false);

  const { activeView, chartFilter, setChartFilter } = reportsContext;

  const intl = useIntl();

  const activeId = reportsContext?.activeSection?.data?.id;

  const activeChart =
    (chartFilter &&
      chartFilter[activeView] &&
      chartFilter[activeView][activeId]) ||
    null;

  const setActiveChartFilter = () => {
    setChartFilter((prevState) => ({
      ...prevState,
      [activeView]: {
        ...prevState[activeView],
        [activeId]: null
      }
    }));
  };

  const [deleteChart] = useMutation(DELETE_CHARTS, {
    client: AccountClient,
    onCompleted(res) {
      if (res?.deleteChart) {
        toast('success', 'reports.widget.deleteWidget.success');
      }
    }
  });

  const deleteCharts = () => {
    deleteChart({
      variables: {
        chartIds: reportsContext?.selectedChart.map((el) => el.chartId)
      }
    }).then(() => {
      reportsContext.setChartListMeta({
        refresh: true,
        data: { resetPage: true }
      });
    });
  };

  return (
    <StyledToolbar className="fx actr">
      <ChartInfoToolbar
        toggleNavMenu={() => reportsContext.setNavOpen(!reportsContext.navOpen)}
        context={reportsContext}
        activeView={reportsContext.activeSection}
      />
      <div className="fx g10">
        {!isEmpty(activeChart) && (
          <Button onClick={() => setActiveChartFilter()} plain>
            <FormattedMessage id="attribute.reset" />
          </Button>
        )}
        {reportsContext?.activeView !== DEFAULT_VIEW && (
          <>
            {reportsContext?.showBulkMenu && (
              <>
                <Badge>
                  {reportsContext?.selectedChart.length +
                    ' ' +
                    getTranslatedText(intl, 'ticket.details.selected')}
                </Badge>
                <ButtonGroup>
                  <DeleteModal
                    modalActivator={
                      <Button icon={<SVGIcon name="Delete" />}>
                        {getTranslatedText(intl, 'common.delete')}
                      </Button>
                    }
                    description={getTranslatedText(
                      intl,
                      'common.deleteAll.description'
                    )}
                    handleDeleteConfirmation={deleteCharts}
                    title={getTranslatedText(
                      intl,
                      'reports.widget.delete.modal.title'
                    )}
                  />
                </ButtonGroup>
              </>
            )}
            {!reportsContext?.showBulkMenu && (
              <AccessControl
                roleToCheck="report.add"
                ldFlag="charts"
                render={
                  <Button
                    id="createChartBtn"
                    onClick={() => {
                      setOpenChart(true);
                    }}
                    primary
                    customClassName="ml-10"
                    icon={<SVGIcon name="Add" color="#ffffff" />}
                  >
                    <FormattedMessage id="reports.widget.title" />
                  </Button>
                }
              />
            )}
          </>
        )}
      </div>
      {openChart && (
        <ChartHome callBack={() => setOpenChart(false)} mode="create" />
      )}
    </StyledToolbar>
  );
};
export default injectIntl(withRouter(ChartToolbar));
